function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { openPinModal } from "@common/actions";
import EditPin from "@common/components/Settings/ParentalControl/EditPin";
import EditTimeLock from "@common/components/Settings/ParentalControl/EditTimeLock";
import SettingItem from "@common/components/Settings/SettingItem";
import { LOCK_PERIODS } from "@common/constants";
import Button from "@material-ui/core/Button";
import React from "react";
import { connect } from "react-redux";
var ParentalControl = /*#__PURE__*/ function(SettingItem) {
    "use strict";
    _inherits(ParentalControl, SettingItem);
    var _super = _create_super(ParentalControl);
    function ParentalControl(props) {
        _class_call_check(this, ParentalControl);
        var _this;
        _this = _super.call(this, props);
        // Pipe onChangeHandler to parent
        _define_property(_assert_this_initialized(_this), "onChangeHandler", function(newProfileSettings) {
            var saveButtonDisabled = JSON.stringify(newProfileSettings.web_settings) === JSON.stringify(_this.props.profileSettings.web_settings);
            _this.setState({
                saveButtonDisabled: saveButtonDisabled
            });
            _this.props.onChangeHandler(newProfileSettings);
        });
        _define_property(_assert_this_initialized(_this), "onEditPinToggle", function(value) {
            _this.setState({
                editPin: value
            });
        });
        _define_property(_assert_this_initialized(_this), "renderLeftButton", function() {
            var _this_props = _this.props, i18n = _this_props.i18n, _$openPinModal = _this_props.openPinModal, profileSettings = _this_props.profileSettings;
            var alwaysLock = profileSettings.web_settings.lockPeriod === LOCK_PERIODS.ALWAYS_LOCK;
            return /*#__PURE__*/ _jsx(Button, {
                classes: {
                    label: "ux-button-label"
                },
                onClick: _$openPinModal,
                disabled: alwaysLock,
                className: "go-back-button raised half-width",
                children: /*#__PURE__*/ _jsx("span", {
                    children: i18n.settings.unlockAll
                })
            });
        });
        _this.state = _object_spread_props(_object_spread({}, _this.state), {
            editPin: false,
            saveButtonDisabled: true
        });
        return _this;
    }
    _create_class(ParentalControl, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                // Show this footer component only when edit pin is not visible
                if (this.state.editPin === false || this.state.saveButtonDisabled !== prevState.saveButtonDisabled) {
                    this.getFooterComponents();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "layout-2-columns",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "layout-column",
                            children: /*#__PURE__*/ _jsx(EditTimeLock, _object_spread_props(_object_spread({}, this.props), {
                                onChangeHandler: this.onChangeHandler
                            }))
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "layout-column",
                            children: /*#__PURE__*/ _jsx(EditPin, _object_spread_props(_object_spread({}, this.props), {
                                onEditPinToggle: this.onEditPinToggle
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return ParentalControl;
}(SettingItem);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings;
    return {
        i18n: i18n,
        profileSettings: profileSettings
    };
};
export default connect(mapStateToProps, {
    openPinModal: openPinModal
})(ParentalControl);
